import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';

import { getLimitInfo } from '@common/core/network/NodeAPI';
import { IUserLimitInfo } from '@loan/vb-node-loan/types';
import { LimitState } from '@common/core/interface/IModel';

export const initState = LimitState.INIT;

export const initLimitInfo = {
  limit: '0',
  limitLeft: '0',
  creditAmt: '0',
  yearRate: '',
  dayRate: '',
  ccyCode: '',
  limitNo: '',
  status: -1,
  interestRate: '',
  overdueRate: '',
  overdueMonthRate: '',
  confirmDay: 0,
  productTag: '',
  extInfo: {
    can_increase_limit: '', // 1: 可提额
    increase_upper_limit: '', // 最高可提额度
  },
  createTime: 0,
  residentType: -1,
  userLimitInfoExtInfo: {
    senceId: '',
    unfreeze_time:-1
  },
  creditNote: {
    proofAddressInback: '',
    declareIncomeGetlimit: '',
    propertyAllow: '',
    userIsHighquality: '',
    approve_limit: '', // 授予的额度
    userdeclare_limit: '', // 用户声明额度
    user_oper_tips: '', // 用户操作提示：can_adjustlimit:可调额
    limit_adjust_step: '', // 额度调整步长，暂定1000
  },
  platform:-1,
  seq: '',
};

const limitInfo = reactive<IUserLimitInfo>(initLimitInfo);
const limitState = ref<LimitState>(initState);

const userInfo = reactive({
  acctNo: '',
  uid: '',
  residentType: -1,
});
const isReady = ref<boolean>(false);
export const useLimit = defineStore(
  'useLimit',
  () => {
    const refreshLimit = async (cache = false) => {
      if (cache && isReady.value === true) {
        return;
      }
      const resp = await getLimitInfo();
      isReady.value = true;
      Object.assign(limitInfo, resp.data || initLimitInfo);
      Object.assign(userInfo, resp.userInfo);
      limitState.value = resp.message;
    };
    return {
      refreshLimit,
      isReady,
      limitInfo,
      limitState,
      userInfo,
    };
  },
  {
    // @ts-ignore
    persist: true,
  },
);
